import { theme as antTheme } from 'antd';
import type * as React from 'react';
import { ThemeProvider } from 'styled-components';
import { uiTheme } from './uiTheme.tsx';

export interface IAntThemeProviderProps<T extends object> {
  children: React.ReactNode;
  theme: T;
}

/**
 * Esponiamo, all'interno del `DefaultTheme` di styled-components, il tema di
 * ant, nello specifico la variabile `token` che contiene i token di ant.
 *
 * Richiede che il ConfigProvider di ant sia dichiarato prima
 * di questo componente.
 */
export function AntThemeProvider<T extends object>(
  props: IAntThemeProviderProps<T>,
) {
  const { token } = antTheme.useToken();

  // TODO Al momento se si prova a rimuovere `any`, si riceve l'errore di TS che
  // indica che l'espressione è troppo complessa. C'è da identificare il problema
  // e risolverlo.
  // L'errore si presenta solo via linting.
  const mergedTheme = { ...uiTheme, ...props.theme, ...token } as any;

  return <ThemeProvider theme={mergedTheme}>{props.children}</ThemeProvider>;
}
